import { categories, categoryImages } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function CategoriesSection() {
  return (
    <section id="categories" className="py-16 md:py-24 bg-secondary-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-4 tracking-wide">
              EXPLORE CATEGORIES
            </span>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              Browse All Product{" "}
              <span className="text-accent-600">Categories</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              Explore all 14 fashion categories organized in the Vigorbuy
              Spreadsheet. Click any category to browse products on the main
              site.
            </p>
          </div>

          {/* Category Grid */}
          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"
            data-product-shop
          >
            {categories.map((cat) => (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-300 hover:shadow-lg hover:shadow-accent-100/30 transition-all duration-300 cursor-pointer"
              >
                {/* Category Image */}
                <div className="relative aspect-[4/3] overflow-hidden bg-secondary-100">
                  <img
                    src={categoryImages[cat.seq]}
                    alt={`${cat.name} category - Vigorbuy Spreadsheet`}
                    title={`Vigorbuy Spreadsheet ${cat.name} Category`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Category Info */}
                <div className="p-5 text-center">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors duration-200">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-400 mb-4">
                    Browse {cat.name.toLowerCase()} collection
                  </p>
                  <span className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 text-background-50 text-xs font-semibold rounded-full group-hover:bg-primary-600 transition-all duration-200 whitespace-nowrap">
                    Explore Now
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </div>
              </a>
            ))}
          </div>

          {/* View All Link */}
          <div className="text-center mt-10">
            <Link
              to="/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors duration-200"
            >
              Want to learn more? Read our complete Vigorbuy Spreadsheet guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}